<template>
  <vs-row v-if="value" class="sidebar-item-if-exists">
    <vs-col vs-w="4" class="sidebar-item-name"> {{name}} </vs-col>
    <vs-col vs-w="8"> {{value}} </vs-col>
  </vs-row>
</template>

<script>

export default {
    name: "sidebar-item-if-exists",
    props: {
            name: String,
            value: String,
    },
}
</script>
